import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="compra" className="bg-navy-light py-10 md:py-24 px-4 scroll-mt-10" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-53">
          <div className="bg-navy-dark p-6 md:p-12 rounded-2xl md:rounded-3xl border-2 border-gold shadow-[0_0_50px_rgba(201,168,76,0.15)] relative overflow-hidden" data-id="element-54">
            <div className="absolute top-0 -left-[100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12 animate-[shine_8s_infinite]" data-id="element-55"></div>

            <img src="https://cdn.magicpatterns.com/uploads/kGN58kiv3aS6NYxD8nYWVs/MOCKUP_PNG.png" alt="Estudio Jurídico Listo" className="w-[55%] md:w-[60%] max-w-sm mx-auto mb-5 md:mb-8 drop-shadow-2xl" data-id="element-56" />

            <div className="mb-5 md:mb-8" data-id="element-57">
              <p className="text-gray-400 text-sm md:text-lg mb-1" data-id="element-58">
                Precio Regular:
              </p>
              <p className="text-2xl md:text-3xl text-red-500 line-through font-bold mb-1" data-id="element-59">
                $49.990
              </p>
              <p className="text-gray-300 text-xs md:text-sm uppercase tracking-widest mb-2 md:mb-4" data-id="element-60">
                Precio Especial Hoy
              </p>
              <p className="text-5xl md:text-7xl font-black text-gold drop-shadow-[0_0_10px_rgba(201,168,76,0.5)]" data-id="element-61">
                $19.990
              </p>
              <p className="text-xs md:text-sm text-gray-400 mt-1" data-id="element-62">
                Pago único. Acceso de por vida.
              </p>
            </div>

            <CTAButton className="w-full md:w-auto text-lg md:text-xl py-4 md:py-5 px-6 md:px-10" data-id="element-63" />

            <div className="mt-4 md:mt-6 flex items-center justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-400" data-id="element-64">
              <span data-id="element-65">🔒 Pago 100% Seguro</span>
              <span data-id="element-66">•</span>
              <span data-id="element-67">⚡ Acceso Inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}